import { useEffect } from 'react'
import { Page_Padding } from '../../shared/constants'
import { Box, Grid2, Typography } from '@mui/material'
import Heading from '../../shared/utils/Heading'
import CustomDivider from '../../shared/utils/CustomDivider'
import CourseCard from '../../shared/components/CourseCard'
import { SkeletonCom } from '../../shared/utils/SkeletonCom'
import VideoSection from '../Camps/VideoSection'
import { StarBulletsPoints } from '../../shared/components/StarBulletsPoints'
import { usePageContentWithMeta } from '../../shared/hook/usePageContentWithMeta'
import { getImageUrl } from '../../shared/utils/getImageUrl'
import CourseScroller from '../Home/CourseScroller'
import { useCourses } from '../../assets/api/useGetApi'
import { COURSE_MAP } from '../../shared/utils/config'


const SkillFourTeacher = ({ onLoadingChange = () => { } }) => {

    const { data: Detail, isLoading: isDetailLoading } = usePageContentWithMeta("SKILL4TEACHERS");

    useEffect(() => {
        onLoadingChange(isDetailLoading);
    }, [isDetailLoading, onLoadingChange]);

    

    const { flatData: upSkill4TeacherCourses, isLoading: isLoadingCourse } = useCourses({ course_type: "upskill_teacher" }, 6);

    if (isDetailLoading) return null;

    return (
        <Box className="body camp">
            <Box px={Page_Padding} >
                <Box
                    sx={{
                        position: "relative",
                        // backgroundImage: `url(${Constants.customImages.CampsHeroImg})`,
                        backgroundImage: `url(${getImageUrl(Detail?.content[0]?.data?.imageUrl)})`,
                        backgroundSize: "cover",
                        backgroundPosition: "bottom",
                        backgroundRepeat: "no-repeat",
                        borderRadius: "40px",
                        overflow: "hidden",
                        minHeight: "50vh"
                    }}
                />
                <CustomDivider />
                <Heading Heading={Detail?.content[1]?.data?.subheading} mb={2} />
                <Typography variant="body2" color='grey.400' dangerouslySetInnerHTML={{ __html: Detail?.content[1]?.data?.description }} />
                {/* Upskilling for teachers is to equip educators with new-age knowledge, tools, and strategies that enhance their teaching effectiveness. In today’s rapidly changing education landscape, traditional methods alone are not enough. With the integration of Artificial Intelligence (AI), teachers can now access smarter ways to plan lessons, simplify concepts, personalize learning, and make classroom delivery more impactful
                </Typography> */}
                {/* <CustomDivider size={"1rem"} />
                <Typography variant="body2" color='grey.400'>
                    UpSkilling helps teachers become more effective in their subject expertise and classroom delivery, ensuring they can engage today’s learners with confidence and innovation
                </Typography> */}

                <CustomDivider />
                <Heading
                    Heading={Detail?.content[2]?.data?.subheading}
                    mb={2}
                />
                <Typography variant="body2" color='grey.400' dangerouslySetInnerHTML={{ __html: Detail?.content[2]?.data?.description }} />
                {/* The role of a teacher is no longer limited to delivering lessons from textbooks. Education today demands creativity, adaptability, and technology integration
                </Typography> */}
                <StarBulletsPoints items={Detail?.content[2]?.data?.list} />

                <CustomDivider />
                {/* <Heading
                    Heading={Detail?.content[3]?.data?.subheading}
                    SubHeading={Detail?.content[3]?.data?.heading}
                    mb={2}
                /> */}



                <CourseScroller content={Detail?.content[3]} courses={ upSkill4TeacherCourses} isLoading={isLoadingCourse} category={COURSE_MAP.UPSKILL_4_TEACHER} />


            </Box>
            <CustomDivider />
            <VideoSection size={1.03}>
                {["GWmDPMfhZdY", "OglJfZwE5Qc", "6JIpZfiUqOg"].map((item, index) => (
                    <Box key={index} sx={{ minWidth: "100%" }}>
                        <iframe
                            src={`https://www.youtube.com/embed/${item}?enablejsapi=1&controls=1&modestbranding=1&rel=0&disablekb=1&fs=0`}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title={`Embedded YouTube ${index}`}
                            style={{
                                width: "100%",
                                height: "400px",
                            }}
                        />
                    </Box>
                ))}
            </VideoSection>
            <Box px={Page_Padding} >

                <CustomDivider />
                <Heading
                    Heading={Detail?.content[4]?.data?.subheading}
                    mb={2}
                />
                <Typography variant="body2" color='grey.400' mb={2} dangerouslySetInnerHTML={{ __html: Detail?.content[4]?.data?.description }} />
                {/* Our programs focus on integrating AI tools and techniques into everyday teaching. By learning to leverage AI, teachers gain
                </Typography> */}

                <StarBulletsPoints items={Detail?.content[4]?.data?.list} />

                {/* <CustomDivider orientation="horizontal" size={isSmallScreen ? "20px" : undefined} /> */}
                <CustomDivider />


                <Typography variant="h6" sx={{ color: "red.main", textAlign: "center", lineHeight: "2rem" }} dangerouslySetInnerHTML={{ __html: Detail?.content[5]?.data?.heading }} />
                {/* {Detail?.content[5]?.data?.heading}
                </Typography> */}
                <CustomDivider />
                <Box
                    sx={{
                        position: "relative",
                        // backgroundImage: `url(${Constants.customImages.CampsHeroImg})`,
                        backgroundImage: `url(${getImageUrl(Detail?.content[6]?.data?.imageUrl)})`,
                        backgroundSize: "cover",
                        backgroundPosition: "bottom",
                        backgroundRepeat: "no-repeat",
                        borderRadius: "40px",
                        overflow: "hidden",
                        minHeight: "50vh"
                    }}
                />
                <CustomDivider size={"4rem"} />
                <Heading
                    Heading={Detail?.content[7]?.data?.subheading}
                    mb={2}
                />
                <Typography variant="body2" color='grey.400' mb={2} dangerouslySetInnerHTML={{ __html: Detail?.content[7]?.data?.description }} />
                {/* We believe that empowered teachers create empowered learners. That’s why our upskilling programs are designed to be
                </Typography> */}
                <StarBulletsPoints items={Detail?.content[7]?.data?.list} />

                <CustomDivider />
                <Typography variant="h6" sx={{ color: "red.main", textAlign: "center", lineHeight: "2rem" }} dangerouslySetInnerHTML={{ __html: Detail?.content[8]?.data?.heading }} />
                {/* With our training, teachers don’t just learn new tools—they transform the way they think, teach, and connect with students
                </Typography> */}

            </Box>


        </Box>
    )
}

export default SkillFourTeacher

const styles = {

    subChild: {
        display: "flex",
        flexDirection: "column",
        gap: 0.5
    }
}
